var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7070_238168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0556 7.20305C24.0556 5.09367 22.5041 3.39679 20.587 3.39679C17.9901 3.27539 15.3416 3.22852 12.635 3.22852H11.7913C9.0913 3.22852 6.43817 3.27539 3.8413 3.39726C1.9288 3.39726 0.377238 5.10352 0.377238 7.21289C0.260051 8.88117 0.210363 10.55 0.213176 12.2186C0.208488 13.8874 0.261613 15.5577 0.372551 17.2296C0.372551 19.3389 1.92411 21.05 3.83661 21.05C6.56474 21.1765 9.36318 21.2327 12.2085 21.228C15.0585 21.2374 17.8491 21.178 20.5803 21.05C22.4976 21.05 24.0491 19.3389 24.0491 17.2296C24.1616 15.5562 24.2132 13.8874 24.2085 12.214C24.2191 10.5453 24.1682 8.87492 24.0556 7.20305ZM9.91628 16.8171V7.60617L16.7132 12.2093L9.91628 16.8171Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7070_238168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.212891 0.228516)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.73f26f6515db4d3d9a8b444670ef2337.svg";
export { ForwardRef as ReactComponent };